<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{ $vuetify.lang.t('$vuetify.exportEmployeeModal.exportEmployeeData') }}
                </span>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-form>
                    <v-container>
                        <v-row>
                            <v-radio-group
                                v-model="selected"
                                row>
                                <v-radio
                                    class="col-12"
                                    v-for="(exportType, exportTypeIndex) in exportTypes"
                                    :key="exportTypeIndex"
                                    :label="exportType.text"
                                    :value="exportType.value"
                                ></v-radio>
                            </v-radio-group>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions class="pb-6 pr-6">
                <v-spacer/>
                <v-btn
                    color="primary"
                    outlined
                    @click="closeModal()">
                    {{ $vuetify.lang.t('$vuetify.exportEmployeeModal.cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    @click="submit()">
                    {{ $vuetify.lang.t('$vuetify.exportEmployeeModal.export') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ExportEmployeeModal',
    computed: {
        exportTypes () {
            const options = [
                {
                    text: this.$vuetify.lang.t('$vuetify.exportEmployeeModal.employeeInformation'),
                    value: 'employeeData'
                }, {
                    text: this.$vuetify.lang.t('$vuetify.exportEmployeeModal.lineRegisterCode'),
                    value: 'lineRegisCode'
                }
            ]

            if (process.env.VUE_APP_KBANK_SERVICE === 'true') {
                options.push({
                    text: this.$vuetify.lang.t('$vuetify.exportEmployeeModal.tabletRegisterCode'),
                    value: 'tabletRegisCode'
                })
            }

            return options
        }
    },

    data () {
        return {
            dialog: false,
            selected: 'employeeData'
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        closeModal () {
            this.dialog = false
            this.selected = 'employeeData'
        },

        submit () {
            if (this.selected === 'employeeData') {
                this.$emit('export-employee')
                this.closeModal()
            } else if (this.selected === 'lineRegisCode') {
                this.$emit('export-line-register-code')
                this.closeModal()
            } else {
                this.$emit('export-tablet-register-code')
                this.closeModal()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
